import React from 'react';

interface FormSubmissionsTableProps {
  formSubmissions: any[]; // TODO: Define a proper type for FormSubmission
}

const FormSubmissionsTable: React.FC<FormSubmissionsTableProps> = ({ formSubmissions }) => {
  console.log('FormSubmissionsTable: Received formSubmissions:', formSubmissions, 'Type:', typeof formSubmissions, 'IsArray:', Array.isArray(formSubmissions));

  if (!formSubmissions || !Array.isArray(formSubmissions) || formSubmissions.length === 0) {
    return <p className="text-sm text-gray-600">No form submissions found.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              ID
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Form Type
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Data
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden sm:table-cell"
            >
              Created At
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden md:table-cell"
            >
              Updated At
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {formSubmissions.map((submission) => {
            try {
              return (
                <tr key={submission.id}>
                  <td className="px-3 py-2 whitespace-nowrap text-xs font-medium text-gray-900">
                    {submission.id}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-700">
                    {submission.form_type}
                  </td>
                  <td className="px-3 py-2 text-xs text-gray-700 max-w-xs whitespace-normal break-words">
                    {typeof submission.data === 'object' ? JSON.stringify(submission.data) : String(submission.data)}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-700 hidden sm:table-cell">
                    {new Date(submission.created_at).toLocaleDateString()}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-700 hidden md:table-cell">
                    {new Date(submission.updated_at).toLocaleDateString()}
                  </td>
                </tr>
              );
            } catch (error) {
              console.error('FormSubmissionsTable: Error rendering submission row:', submission, error);
              return (
                <tr key={submission.id || 'error'}>
                  <td colSpan={5} className="px-3 py-2 text-xs text-red-600">
                    Error rendering submission data
                  </td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FormSubmissionsTable; 